/**
 * "Describe a shader..." places a Shader node and puts the cursor in its
 * prompt box. The request is held here, in memory, until that node's composer
 * mounts and claims it, so it never lands in saved node state.
 */

const EVENT = 'genie:shader-composer-focus'
const pending = new Set<string>()

export function requestShaderComposerFocus(nodeId: string): void {
  pending.add(nodeId)
  document.dispatchEvent(new CustomEvent(EVENT, { detail: { nodeId } }))
}

/** True once for a node that asked for focus; the request is cleared. */
export function claimShaderComposerFocus(nodeId: string): boolean {
  return pending.delete(nodeId)
}

/** Calls `onFocus` whenever focus is requested for this node after it mounted. */
export function subscribeShaderComposerFocus(nodeId: string, onFocus: () => void): () => void {
  const handler = (event: Event) => {
    if ((event as CustomEvent<{ nodeId: string }>).detail?.nodeId !== nodeId) return
    if (claimShaderComposerFocus(nodeId)) onFocus()
  }
  document.addEventListener(EVENT, handler)
  return () => document.removeEventListener(EVENT, handler)
}
